namespace RioERP.Masters {
    export namespace PendingOrderJobSettingsService {
        export const baseUrl = 'Masters/PendingOrderJobSettings';

        export declare function Create(request: Serenity.SaveRequest<PendingOrderJobSettingsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PendingOrderJobSettingsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PendingOrderJobSettingsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PendingOrderJobSettingsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/PendingOrderJobSettings/Create",
            Update = "Masters/PendingOrderJobSettings/Update",
            Delete = "Masters/PendingOrderJobSettings/Delete",
            Retrieve = "Masters/PendingOrderJobSettings/Retrieve",
            List = "Masters/PendingOrderJobSettings/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PendingOrderJobSettingsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
